/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { goBack, push } from "connected-react-router";
import { bool, string, shape } from "prop-types";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import { actions as softTokenActions, selectors as softTokenSelectors } from "reducers/softToken";
import { actions as afipPaymentLinkActions, selectors as afipPaymentLinkSelectors } from "reducers/afipPaymentLink";
import Button from "pages/_components/Button";
import Checkbox from "pages/_components/Checkbox";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import ProductList from "pages/_components/product/List";
import VepsHistoricItem from "../vepsHistoric/components/ItemRow";
import TitleColumns from "../vepsHistoric/components/TitleColums";

const VepPaymentConfirm = ({ isDesktop, fetching, deviceStatus, vepPaymentData }) => {
    const [veps, setVeps] = useState([]);
    const [accountLabel, setAccountLabel] = useState(null);
    const [trxData, setTrxData] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (vepPaymentData) {
            const { selectedVeps, account, accountLabel: accLabel, vepList, cuitCreator, totalAmountSelected, amount: totalAmount } = vepPaymentData;
            let accLabelValue = null;
            if (account !== null) {
                accLabelValue = `${i18n.get(`productType.${account?.type}`, "")} ····${account?.accountNumber?.slice(-4)} ${account?.type
                    } ${i18n.get(`currency.label.${account?.currency}`, "")}` || "Error obteniendo la cuenta";
                setAccountLabel(accLabelValue);
            } else if (accLabel) {
                accLabelValue = accLabel;
                setAccountLabel(accLabel);
            } else {
                setAccountLabel("Error obteniendo la cuenta");
            }

            if (selectedVeps) {
                setVeps(selectedVeps);
            } else if (vepList) {
                setVeps(vepList);
            }

            const params = {
                vepList: selectedVeps || vepList,
                accountId: account?.id,
                amount: {
                    quantity: totalAmountSelected || totalAmount?.quantity,
                    currency: "ARS",
                },
                accountLabel: accLabelValue,
                cuitCreator,
                idTransaction: vepPaymentData.idTransaction,
            };

             setTrxData(params);
        }
    }, [vepPaymentData]);

    const onBack = () => {
        dispatch(goBack());
    };

    return (
        <>
            <Notification scopeToShow="VepPaymentConfirmPage" />
            <ResponsiveHeader id="vep.new.payment.title" defaultTitle="Pago VEP" onClickBack={onBack} />
            <MainContainer className="discounts-echeq-review">
                <CustomText
                    text={i18n.get("vep.payment.data.review.title", "Confirmá la transacción")}
                    textType="TEXT"
                    className="discounts-echeq-review__date-control"
                    defa
                />
                <GridTable className="deposits-details-list details">
                    <GridTable.Container columns={isDesktop ? 4 : 1} rows={isDesktop ? 1 : 4}>
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <CustomData
                                titleText={i18n.get("vep.payment.data.debit.account", "Cuenta débito")}
                                titleClass="text-Primary-primary-color"
                                valueText={accountLabel}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                            <CustomData
                                titleText={i18n.get("vep.payment.cuitCreator", "CUIT/CUIL generador")}
                                titleClass="text-Primary-primary-color"
                                valueText={vepPaymentData?.cuitCreator}
                            />
                        </GridTable.Data>

                        <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 3}>
                            <CustomData
                                titleText={i18n.get("vep.payment.total.items", "Cantidad de VEPs")}
                                valueText={veps?.length}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 4}>
                            <CustomData
                                titleText={i18n.get("vep.payment.total.amount", "Monto total")}
                                valueText={vepPaymentData?.totalAmountSelected || vepPaymentData?.amount?.quantity || 0}
                                valueTextType="ARS"
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
                {veps?.length > 0 && (
                    <ProductList
                        onLoadMoreClick={() => { }}
                        fetchingWithPreviousData
                        fetching={false}
                        items={veps}
                        noDataText="vep.historic.list.empty"
                        noFiltersDataText="global.no.results"
                        renderItem={(item) => (
                            <GridTable.Container
                                key={`vep-historic-item-${item.id}`}
                                renderAs="div"
                                className={!isDesktop && "box box-shadow"}>
                                <VepsHistoricItem vep={item} isDesktop={isDesktop} isReviewPage />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="vep-payment-review-table tablelist received">
                                {isDesktop && (
                                    <GridTable.Header>
                                        <GridTable.Container>
                                            <TitleColumns />{" "}
                                        </GridTable.Container>
                                    </GridTable.Header>
                                )}
                                <GridTable.Body>{listItem}</GridTable.Body>
                            </GridTable>
                        )}
                    </ProductList>
                )}
                <Formik
                    validateOnBlur
                    validateOnChange={false}
                    initialValues={{
                        credential: "",
                    }}
                >
                    {() => (
                        <>
                            <Row className="form-actions">
                                <GeneralCredentialForm
                                    transactionData={trxData}
                                    type="otp"
                                    action={afipPaymentLinkActions.processVepPayment}
                                    idActivity="veps.process.payment"
                                    hideIndications
                                />
                            </Row>
                        </>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

VepPaymentConfirm.propTypes = {
    isDesktop: bool.isRequired,
    deviceStatus: string.isRequired,
    vepPaymentData: shape({}).isRequired,
    fetching: bool.isRequired,
    // tokenInfo: shape({}).isRequired,
};
const mapStateToProps = (state) => ({
    // tokenInfo: softTokenSelectors.getTokenInfo(state),
    deviceStatus: softTokenSelectors.getDeviceStatus(state),
    fetching: afipPaymentLinkSelectors.getFetching(state),
    vepPaymentData: afipPaymentLinkSelectors.getVepPaymentData(state),
});
export default connect(mapStateToProps)(VepPaymentConfirm);
